import * as fromExpertise from '../actions/expertise.actions';
import { createSelector } from '@ngrx/store';
import { Pagination } from '../../shared/models/pagination';
import { Expertise } from '../../shared/models/expertise';
import { Prestation } from '../../shared/models/prestation';

export interface ExpertiseState {
  expertises: any[];
  openExpertises: any[];
  pagination: Pagination;
  lastNewId : number;
  newPrestation: Prestation;
}

const initState: ExpertiseState = {
  expertises: [],
  openExpertises: [],
  pagination: {
    sortField: 'number',
    sortOrder: 2,
    filters: null,
    first: 1,
    rows: 10,
    totalCount: 0,
  },
  lastNewId: -1,
  newPrestation: new Prestation,
};

export function expertiseReducer( state: ExpertiseState = initState, action: fromExpertise.expertiseActions): ExpertiseState {
    switch ( action.type ) {
     case fromExpertise.ADD_EXPERTISE: {
       return {
         ...state,
         lastNewId: state.lastNewId - 1,
         openExpertises: [
           ...state.openExpertises,
           Object.assign({id:state.lastNewId - 1, name: '', date_in: new Date()})
         ],
       };
     }
    case fromExpertise.LOAD_EXPERTISES: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          sortField: action.sortField,
          sortOrder: action.sortOrder,
          filters: action.filters,
          first: action.first,
          rows: action.rows,
        }
      };
    }
    case fromExpertise.LOAD_EXPERTISES_SUCCESS : {
      return {
        ...state,
        expertises: action.expertises,
        pagination: {
          ...state.pagination,
          totalCount: action.totalCount
        }
      };
    }
    case fromExpertise.OPEN_TAB : {
       if (state.openExpertises.find(c => c.id == action.id)) {
         return {
           ...state
         };
       }
       return {
         ...state,
           openExpertises: [
             ...state.openExpertises,
             {
               id: action.id,
               name: 'Chargement...',
               loading: true,
             }
           ]
       };
    }
     case fromExpertise.CLOSE_TAB:  {
       return {
         ...state,
         openExpertises: state.openExpertises.filter(c => c.id.toString() !== action.id.toString())
       };
     }

    case fromExpertise.LOAD_EXPERTISE_SUCCESS : {
       let oc = state.openExpertises.map(c => {
         if (c.id == action.expertise.id) {
           return action.expertise;
         }
         return c;
       });
       return {
         ...state,
           openExpertises: oc
       };
    }

    case fromExpertise.SAVE_EXPERTISE : {
       const cs = state.openExpertises.map(c =>{
         if (c.id.toString() === action.expertise.id.toString()) {
           return Object.assign(action.expertise, {saved:false});
         }
         return c;
       });
       return {
         ...state,
           openExpertises: cs
       };
    }
    case fromExpertise.SAVE_EXPERTISE_SUCCESS : {
       const cs = state.openExpertises.map(c =>{
         if (c.id.toString() === action.id.toString()) {
           return Object.assign(action.expertise, {oldId: action.id, saved:true});
         }
         return c;
       });
       return {
         ...state,
           openExpertises: cs
       };
    }
    case fromExpertise.SAVE_EXPERTISE_ERROR : {
       const cs = state.openExpertises.map(c =>{
         if (c.id.toString() === action.id.toString()) {
           return Object.assign({}, c, {errors:action.error});
         }
         return c;
       });
       return {
         ...state,
           openExpertises: cs
       };
    }
    case fromExpertise.UPDATE_PRESTATION_SUCCESS : {
       let cs = state.openExpertises.map(c => {
         if (c.id.toString() === action.expertiseId.toString()) {
             c.uidUpdate++;
             c.workflow = action.prestation.expertise.workflow;
             c.prestations = c.prestations.map(p => {
               if (p.id.toString() === action.prestationId.toString()) {
                 return Object.assign(action.prestation, {saved: true});
               }
               return p;
             });
             return c;
         }
         return c;
       });
       return {
         ...state,
           openExpertises: cs
       };
    }
    case fromExpertise.ADD_PRESTATION : {

       const cs = state.openExpertises.map(c => {
         if (c.id.toString() === action.expertiseId.toString()) {
             c.prestations = [action.prestation].concat(c.prestations);
         }
         return c;
       });
       return {
         ...state,
           openExpertises: cs,
           newPrestation: new Prestation,
       };
    }
    case fromExpertise.SET_CONSIGNEMENT : {
      const eIdx = state.openExpertises.findIndex(e => e.id.toString() === action.consignment.expertise_id.toString());
      console.log(eIdx, action.consignment, state.openExpertises);
      if (eIdx >= 0) {
          const cIdx = state.openExpertises[eIdx].consignments.findIndex(c => c.id.toString() === action.consignment.id.toString());
          if (cIdx >= 0) {
            return {
              ...state,
                openExpertises: state.openExpertises.map((e, idx) => idx === eIdx ? Object.assign((new Expertise),{
                  ...e,
                  consignments: state.openExpertises[eIdx].consignments.map((c, idx2) => idx2 === cIdx ? action.consignment : c)
                }): e),
            };
          }
          return {
            ...state,
              openExpertises: state.openExpertises.map((e, idx) => idx === eIdx ? Object.assign((new Expertise),{
                ...e,
                consignments: [
                  ...state.openExpertises[eIdx].consignments,
                  action.consignment
                ]
              }): e),
          };

      }
      return state;
   }
   case fromExpertise.DELETE_CONSIGNEMENT : {
    const eIdx = state.openExpertises.findIndex(e => e.id.toString() === action.expertise_id.toString());
    if (eIdx >= 0) {
          return {
            ...state,
              openExpertises: state.openExpertises.map((e, idx) => idx === eIdx ?  Object.assign((new Expertise),{
                ...e,
                consignments: state.openExpertises[eIdx].consignments.filter((c) => c.id.toString() !== action.id.toString())
              }): e),
          };
        }
    return state;
 }
    case fromExpertise.CANCEL_ADD_PRESTATION : {
       const cs = state.openExpertises.map(c => {
         if (c.id.toString() === action.expertiseId.toString()) {
             c.prestations = c.prestations.filter(p => p.id !== action.prestationId);
         }
         return c;
       });
       return {
         ...state,
           openExpertises: cs,
           newPrestation: new Prestation,
       };
    }
   case fromExpertise.DELETE_PRESTATION_SUCCESS : {
       let cs = state.openExpertises.map(c => {
         if (c.id.toString() === action.expertiseId.toString()) {
             c.prestations = c.prestations.filter(p =>  (p.id.toString() !== action.id.toString()));
             return c;
         }
         return c;
       });
       return {
         ...state,
           openExpertises: cs
       };
    }
    default:
        return state;
    }
}


export const selectExpertise = (state: any) => state.expertise;
export const selectExpertises = createSelector(selectExpertise, (exp) => exp && exp.expertises);
export const selectExpertisePagination = createSelector(selectExpertise, (exp) => exp && exp.pagination);
export const selectExpertiseNewPrestation = createSelector(selectExpertise, (exp) => exp && exp.newPrestation);

export const selectExpertiseCount = createSelector(selectExpertise, (exp) => exp && exp.pagination && exp.pagination.totalCount);
export const selectOpenExpertises = createSelector(
  selectExpertise,
  (expertise) => {
    return expertise && expertise.openExpertises;
  }
);

export const selectOpenExpertise = createSelector(
  selectExpertise,
  (expertises, props) => {
    let ar = expertises.expertises.filter(e => e.id.toString() === props.id.toString());
    if (ar.length === 0) return null;
    return ar[0];
  }
);
